import React from 'react';
import { Container, wrap } from 'AppReact';
import { SolidButton } from './../../../../common/molecules';
import { ButtonWrapper, Wrapper } from './wrappers';
import { Description } from '../../../../common/atoms';


const WrappedButton = wrap(SolidButton, ButtonWrapper)

const ModalBody = Container({
  name: 'ModalBody',
  props: {  },
  elements: [

    {
      component: Description,
      name: 'Description',
      bindings: ({ }) => ({}),
      displayValue: () => 'There is already a saved application associated with this email address. Continuing will overwrite you saved application. Click the button below to get an email with a link to continue your saved application.',
    },
    {
      wrapper: Wrapper,
      name: 'ButtonsWrapper',
      elements: [
        {
          component: WrappedButton,
          name: 'SendEmailButton',
          bindings: ({ }) => {
            return ({ title: 'Continue Saved Application', big: true, disabled: false })
          },
        },
        {
          component: WrappedButton,
          name: 'OverrideButton',
          bindings: ({ }) => {
            return ({ title: 'Override Saved Application', big: true, disabled: false })
          },
        },
      ]

    },
  ]
})

export default ModalBody;
